import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BaseService } from '@library-shared/base/base.service';
import { ApiRecordReturn } from '@library-shared/models/api-record-return';
import { ApiRecordsReturn } from '@library-shared/models/api-records-return';
import { ApiReturn } from '@library-shared/models/api-return';
import { CCInfo } from '@library-shared/models/cc-info';
import { spPayment_By_Session_ID } from '@models/StoredProcs/spPayment_By_Session_ID';
import { spTicket_Paid_By_Payment_ID } from '@models/StoredProcs/spTicket_Paid_By_Payment_ID';
import { tPayment } from '@models/Tables/tPayment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class PaymentService extends BaseService {
    private apiURL = environment.apiURL + '/api/payment'; // URL to web api

    Process_Payment(req: { ccInfo: CCInfo }): Observable<ApiRecordReturn<tPayment>> {
        const url = `${this.apiURL}/Process_Payment`;
        return this.http
            .post<ApiRecordReturn<tPayment>>(url, req, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    Payment_CalculateProcessingFee(
        amount_to_pay: number,
        ticket_session_ids: string[]
    ): Observable<ApiRecordReturn<{ total_processing_fee: number; total_with_fee: number }>> {
        const url = `${this.apiURL}/Payment_CalculateProcessingFee`;
        const req = { amount_to_pay, ticket_session_ids };
        return this.http
            .post<ApiRecordReturn<{ total_processing_fee: number; total_with_fee: number }>>(url, req, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    Payment_By_Session_ID(): Observable<ApiRecordsReturn<spPayment_By_Session_ID>> {
        const url = `${this.apiURL}/Payment_By_Session_ID`;
        return this.http
            .post<ApiRecordsReturn<spPayment_By_Session_ID>>(url, {}, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    Payment_ByID(req: { payment_id: string }): Observable<ApiRecordReturn<tPayment>> {
        const url = `${this.apiURL}/Payment_ByID`;
        return this.http
            .post<ApiRecordReturn<tPayment>>(url, req, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    Ticket_Paid_By_Payment_ID(req: {
        payment_id: string;
        }
        )
          : Observable<ApiRecordsReturn<spTicket_Paid_By_Payment_ID>> {
                const url = `${this.apiURL}/Ticket_Paid_By_Payment_ID`;
                return this.http.post<ApiRecordsReturn<spTicket_Paid_By_Payment_ID>>(url, req, this.requestOptions).pipe(catchError(e => this.handleError(e)));
        }
}
